import { Outlet } from "@tanstack/react-router"
import { FlashComponent } from "./FlashComponent"

export function RootComponent() {
  return (
    <FlashComponent>
      <Outlet />
    </FlashComponent>
  )
}
